<template>
  <div class="user-page-stat">
    <div class="user-page-stat-block" @click="clickAnswer">
      <div class="user-page-stat-block-title">{{lang.answer}}</div>
      <div>
        <span class="user-page-stat-block-value">{{answer}}</span>
        <span class="user-page-stat-block-unit">{{lang.answer_count}}</span>
      </div>
    </div>
    <div class="user-page-stat-vl"></div>
    <div class="user-page-stat-block" @click="clickReceive">
      <div class="user-page-stat-block-title">{{lang.receive}}</div>
      <div>
        <span class="user-page-stat-block-value">{{receive}}</span>
        <span class="user-page-stat-block-unit">{{lang.receive_count}}</span>
      </div>
    </div>
    <div class="user-page-stat-vl"></div>
    <div class="user-page-stat-block" @click="clickAnswerRate">
      <div class="user-page-stat-block-title">{{lang.answer_rate}}</div>
      <div>
        <span class="user-page-stat-block-value">{{answer_rate}}</span>
        <span class="user-page-stat-block-unit">{{lang.answer_rate_count}}</span>
      </div>
    </div>
    <div class="user-page-stat-vl"></div>
    <div class="user-page-stat-block" @click="clickPv">
      <div class="user-page-stat-block-title">{{lang.pv}}</div>
      <div>
        <span class="user-page-stat-block-value">{{pv}}</span>
        <span class="user-page-stat-block-unit">{{lang.pv_count}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'util'
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    lang: {
      type: Object,
      default () {
        return {
          answer: '已回答',
          answer_count: '次',
          receive: '已投递',
          receive_count: '次',
          answer_rate: '回答率',
          answer_rate_count: '%',
          pv: '已浏览',
          pv_count: ''
        }
      }
    }
  },
  computed: {
    answer () {
      return format('%d', this.data.answer || 0)
    },
    receive () {
      return format('%d', this.data.receive || 0)
    },
    answer_rate () {
      let rate = this.data.answer_rate * 100 || 0
      return format('%d', rate.toFixed(2))
    },
    pv () {
      return format('%d', this.data.pv || 0)
    }
  },
  methods: {
    clickAnswer () { this.$emit('clickAnswer') },
    clickReceive () { this.$emit('clickReceive') },
    clickAnswerRate () { this.$emit('clickAnswerRate') },
    clickPv () { this.$emit('clickPv') }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.user-page-stat {
  color: var(--colorGray1);
  display: inline-flex;

  & .user-page-stat-vl {
    width: 1px;
    border-left: 1px dotted var(--colorDisabled);
    height: 44px;
    margin: 0 20px;
  }
  & .user-page-stat-block {
    & .user-page-stat-block-title {
      margin-bottom: 14px;
    }
    & .user-page-stat-block-value {
      font-size: var(--textSize1);
      color: var(--colorMain);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/user/PageStat.vue